// TODO : This will need updating to Carbon 2

import React from 'react';
import NextLink from 'next/link';
import classNames from 'classnames';

// Types
import { LinkProps, LinkVariantType } from '../../types/actions/links';

// Services
import { validate } from '../../services/actions/link';

// Components
import { Icon } from '../Display/Icon';
import { Tooltip } from '../Display/Tooltip';

export const Link = (props: LinkProps) => {
  validate(props);

  const {
    id,
    to,
    rel,
    type,
    icon,
    target,
    onClick,
    variant,
    children,
    className,
  } = props;

  const formattedUrl = {
    default: to,
    mailto: `mailto:${to}`,
    telephone: `tel:${to}`,
  }[type];

  const variantType = {
    icon: 'icon' as LinkVariantType,
    'icon-button': 'icon-button' as LinkVariantType,

    'link-default': undefined,
    'link-subtle': 'subtle' as LinkVariantType,
    'link-secondary': 'secondary' as LinkVariantType,

    'button-default': undefined,
    'button-link': 'link' as LinkVariantType,
    'button-clear': 'clear' as LinkVariantType,
    'button-primary': 'primary' as LinkVariantType,
    'button-contrast': 'contrast' as LinkVariantType,
    'button-negative': 'negative' as LinkVariantType,
    'button-secondary': 'secondary' as LinkVariantType,
  }[variant];

  const rootClassNames = classNames({
    link: variant.startsWith('link-'),
    button: variant.startsWith('button-'),
    'link--subtle': variant === 'link-subtle',
  });

  return (
    <Tooltip
      id={id}
      tooltip={typeof children === 'string' ? children : undefined}
    >
      <NextLink
        rel={rel}
        target={target}
        onClick={onClick}
        href={formattedUrl}
        data-tooltip-id={id}
        data-type={variantType}
        className={classNames(rootClassNames, {
          [`${className}`]: className,
        })}
        prefetch={type === 'default'}
      >
        {!icon && children}

        {icon && variantType !== 'icon-button' && (
          <>
            {icon?.position === 'left' && <Icon icon={icon.definition} />}

            <span className={classNames({ 'ml-2': variantType === 'icon' })}>
              {children}
            </span>

            {icon && icon?.position === 'right' && (
              <Icon icon={icon.definition} />
            )}
          </>
        )}

        {icon && variantType === 'icon-button' && (
          <>
            <Icon icon={icon.definition} />
            <span className="sr-only">{children}</span>
          </>
        )}
      </NextLink>
    </Tooltip>
  );
};
